import { css } from 'lit-element';
const style = css`
fc-input[type="currency"] {
  --fc-input-prefix-width: 10px;
}

:host([align="column"]) fc-input {
  --fc-input-width: 100%;
}`;

export default style;
